import { STATE_META, type CaseState } from '../data/sampleData';

export function StatusPill({ state }: { state: CaseState }) {
  const meta = STATE_META[state];
  return (
    <span className="pill">
      <span className={`pill-dot dot-${meta.dot}`}></span>{meta.label}
    </span>
  );
}
